import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Button from "@mui/material/Button";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { alpha, useTheme } from "@mui/material/styles";

/**
 * Enlace claro hacia el login en pantallas públicas (recupero de clave, etc.)
 */
function BackToLoginButton({ sx = {} }) {
  const theme = useTheme();
  return (
    <Button
      component={RouterLink}
      to="/login"
      startIcon={<ArrowBackRoundedIcon />}
      variant="outlined"
      color="primary"
      size="small"
      sx={{
        alignSelf: "flex-start",
        textTransform: "none",
        fontWeight: 600,
        borderWidth: 2,
        borderColor: alpha(theme.palette.primary.main, 0.45),
        transition: "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease",
        "&:hover": {
          borderWidth: 2,
          transform: "translateX(-2px)",
          boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.25)}`,
        },
        ...sx,
      }}
    >
      Volver al inicio de sesión
    </Button>
  );
}

export default BackToLoginButton;
